module.exports = __webpack_public_path__ + "img/Group 359.a33c7206.svg";